import { eventBus } from '../../lib/event-bus/event-bus';
import { CONTACT_US_OPEN_MODAL } from '../../lib-sat/contact-us/event';
import { assertIsUploaderEvent } from '../../lib-sat/uploader/core/assert';

var fData = window.qgQueryFragmentHelper.getFragmentStringFromUrl();
if (fData != null) {
    $('#' + fData)
        .find('.collapse')
        .collapse('show');
}

$('[data-toggle=collapse]').click(function () {
    let $icon = $(this).find('i');
    let $collapseBox = $(this).parent().parent().parent().find('.collapse');
    if ($collapseBox.hasClass('show')) {
        $icon.removeClass('fa-chevron-up').addClass('fa-chevron-down');
    } else {
        $icon.removeClass('fa-chevron-down').addClass('fa-chevron-up');
    }
});

$('.collapse').on('hide.bs.collapse', function () {
    let $header = $(this).siblings('.card-header');
    let $icon = $header.find('i');
    $icon.removeClass('fa-chevron-up').addClass('fa-chevron-down');
});

$('.contact-us-button').on('click', () => {
    import(
        /* webpackMode: "lazy-once" */
        `../user/qg-contact-us`
    ).then(function () {
        setTimeout(() => {
            eventBus.emit(CONTACT_US_OPEN_MODAL, { defaultQuestionType: 'question' });
        }, 100);
    });
});

const urlParams  = new URLSearchParams(window.location.search);
const paramValue = urlParams.get('question');

if (paramValue) {
    import(
        /* webpackMode: "lazy-once" */
        `../user/qg-contact-us`
    ).then(function () {
        setTimeout(() => {
            eventBus.emit(CONTACT_US_OPEN_MODAL, { defaultQuestionType: paramValue });
        }, 100);
    });
}

$('.contact-us-feature-button').on('click', () => {
    import(
        /* webpackMode: "lazy-once" */
        `../user/qg-contact-us`
    ).then(function () {
        setTimeout(() => {
            eventBus.emit(CONTACT_US_OPEN_MODAL, { defaultQuestionType: 'feature' });
        }, 100);
    });
});
